import { withTranslation } from "react-i18next";

import { HeaderStyled, Linear, Logo } from "./Header.styled";
import LogoHeader from "../../Assets/Img/logo-sendola.png";

// Own Component
import Link from "../Link";

const Header = () => {
  return (
    <>
      <Linear />
      <HeaderStyled className="header">
        <Logo>
          <Link href="/">
            <img src={LogoHeader} alt="logo-header" />
          </Link>
        </Logo>
      </HeaderStyled>
    </>
  );
};

export default withTranslation("ns")(Header);
